var r=function(r){for(var n=Array(r.length),t=0;t<r.length;++t)n[t]=r[t];return n},n=function(r){return Array.isArray(r)?r:[r]},t=function(r){return Array.isArray(r)?r[0]:r};export{n as asArray,t as getFirst,r as toArray};
//# sourceMappingURL=array.js.map
